import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const SelectionPage = lazy(() => import('../pages/selection/page'));
const AnalyzingPage = lazy(() => import('../pages/analyzing/page'));
const ResultPage = lazy(() => import('../pages/result/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/selection',
    element: <SelectionPage />,
  },
  {
    path: '/analyzing',
    element: <AnalyzingPage />,
  },
  {
    path: '/result',
    element: <ResultPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
